/*
 * @Author: your name
 * @Date: 2020-12-03 15:25:00
 * @LastEditTime: 2021-02-04 09:48:48
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/utils/decorators.js
 */

const loading = (loadingArgName) => (target, name, descriptor) => {
  const fn = descriptor.value
  descriptor.value = async function (...arg) {
    this[loadingArgName] = true
    try {
      await fn.apply(this, arg)
    } catch (error) {
      console.error(error)
    } finally {
      this[loadingArgName] = false
    }
  }
  return descriptor
}

const vuexStoreLoading = (target, name, descriptor) => {
  const fn = descriptor.value
  descriptor.value = async function (...arg) {
    this.$store.commit('showLoading')
    try {
      await fn.apply(this, arg)
    } catch (error) {
      console.error(error)
    } finally {
      this.$store.commit('closeLoading')
    }
  }
  return descriptor
}

const emitLoading = (eventName) => (target, name, descriptor) => {
  const fn = descriptor.value
  descriptor.value = async function (...arg) {
    this.$emit(eventName, true)
    await fn.apply(this, arg)
    this.$emit(eventName, false)
  }
  return descriptor
}
const showNotifyMsg = function (message, type = '') {
  const data = type ? { message, type } : { message }
  this.$createNotify({
    $props: data,
  })
    .show()
}

const vuexLoading = (target, name, descriptor) => {
  const fn = descriptor.value
  descriptor.value = async function (...arg) {
    try {
      this.$store.commit('showLoading')
      await fn.apply(this, arg)
      const message = 'Thank you for reporting a bug!'
      showNotifyMsg.call(this, message)
    } catch (error) {
      console.error(error)
      const message = 'Sorry, failed to report a bug!'
      showNotifyMsg.call(this, message, 'danger')
    } finally {
      this.$store.commit('closeLoading')
      this.showReportBugPopupDialog = false
    }
  }
  return descriptor
}

export {
  loading,
  emitLoading,
  vuexLoading,
  vuexStoreLoading,
}
